/**
 * Compteur qui monte : la valeur affichée part de 0 au montage (puis de la
 * valeur courante à chaque changement de cible) et rejoint la cible en
 * `duree` ms, ease-out cubique, sur `requestAnimationFrame`. Sous
 * `prefers-reduced-motion: reduce`, la cible s'affiche d'un coup.
 *
 * React 18 et 19 (aucune API propre à 19) : consommé tel quel par Helios.
 */
import { useEffect, useRef, useState } from "react";

export function mouvementReduit(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function useCompteur(cible: number, duree = 600): number {
  const [affiche, setAffiche] = useState(0);
  const courant = useRef(0);

  useEffect(() => {
    if (!Number.isFinite(cible)) return;
    if (mouvementReduit() || duree <= 0 || typeof requestAnimationFrame !== "function") {
      courant.current = cible;
      setAffiche(cible);
      return;
    }
    const de = courant.current;
    const debut = performance.now();
    let raf = 0;
    const pas = (t: number) => {
      const p = Math.min(1, (t - debut) / duree);
      const e = 1 - Math.pow(1 - p, 3);
      const v = p >= 1 ? cible : de + (cible - de) * e;
      courant.current = v;
      setAffiche(v);
      if (p < 1) raf = requestAnimationFrame(pas);
    };
    raf = requestAnimationFrame(pas);
    return () => cancelAnimationFrame(raf);
  }, [cible, duree]);

  return affiche;
}
